/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-rail': {
    width: 6,
    height: 8,
    viewBox: '0 0 6 8',
    data: '<path pid="0" d="M4.873 6.16h-.876c-.122 0-.22-.101-.22-.225s.098-.224.22-.224h.876c.121 0 .22.1.22.224a.222.222 0 0 1-.22.224m-2.997 0H1c-.122 0-.22-.1-.22-.224s.098-.224.22-.224h.876c.122 0 .22.1.22.224a.222.222 0 0 1-.22.224m-.431-3.497H4.6c.15 0 .272.11.272.243l-.317 1.72c0 .134-.122.242-.272.242H1.75c-.15 0-.271-.108-.271-.242l-.306-1.72c0-.134.122-.243.272-.243M3 .448c.296 0 .537.246.537.548H2.463c0-.302.24-.548.537-.548m2.372.548H3.976A.987.987 0 0 0 3 0a.987.987 0 0 0-.976.996H.628a.634.634 0 0 0-.628.64v4.84c0 .355.281.641.628.641H1.035l-.377.527c-.071.1-.05.24.049.313a.215.215 0 0 0 .306-.05l.565-.79h2.843l.565.791a.218.218 0 0 0 .307.049.227.227 0 0 0 .048-.313l-.376-.527H5.372A.634.634 0 0 0 6 6.477v-4.84a.634.634 0 0 0-.628-.641" _fill="#2D0645" fill-rule="evenodd"/>'
  }
})
